(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('pharmacy', {
                parent: 'entity',
                url: '/pharmacy',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Pharmacy'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pharmacy/list/pharmacy.html',
                        controller: 'PharmacyController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
